<template>
  <div class="userPay container">

    <!-- ------------------------------- Modal: User Salary ------------------------------------------ -->

	<div>
		<CModal title="User Pay" color="info" :show.sync="salaryModal" size="lg">	
			<div slot="header">
				<h5>{{user.name}}, Department: {{user.deptName}}</h5>
			</div>	
			<div slot="footer">
				<button class="btn btn-info" v-on:click.prevent="serverCall('saveUserSalary')">Save</button>
				<button class="btn btn-info ml-2" v-on:click.prevent="salaryModal=false">Close</button>
			</div>

			<form>

			<div class="form-group row">

				<div class="col-sm-6">
					<div class="card" style="background-color:lightblue">

						<h5 class="card-title ml-2 text-center">Pay</h5>
						<div class="form-group row">
							<label for="basePay" class="col-sm-6 ml-2 col-form-label text-right">Base Pay</label>
							<div class="col-sm-5">
								<input type="number" id="basePay" class="form-control" 
										v-model="user.basePay">
							</div>
						</div>
						<div class="form-group row">
							<label for="hraPay" class="col-sm-6 ml-2 col-form-label text-right">HRA</label>
							<div class="col-sm-5">
								<input type="number" id="hraPay" class="form-control" 
										v-model="user.hraPay">
							</div>
						</div>
						<div class="form-group row">
							<label for="otherPay" class="col-sm-6 ml-2 col-form-label text-right">Other</label>
							<div class="col-sm-5">
								<input type="number" id="otherPay" class="form-control" 
										v-model="user.otherPay">			
							</div>	
						</div>
						<div class="form-group row">							
							<label for="salary" class="col-sm-6 ml-2 col-form-label text-right">Total Salary</label>
							<div class="col-sm-5">
								<input type="number" id="salary" class="form-control" 
										v-model="user.salary">
							</div>
						</div>

						<br>
						<h5 class="card-title ml-2 text-center">Working Days</h5>
						<div class="form-group row">
							<label for="workingPercent" class="col-sm-6 ml-2 col-form-label text-right">Working %</label>
							<div class="col-sm-5">
								<input type="number" id="workingPercent" class="form-control" 
										v-model="user.workingPercent">
							</div>
						</div>
						<div class="form-group row">
							<label for="daysOffPerYear" class="col-sm-6 ml-2 col-form-label text-right">Leave/Year</label>
							<div class="col-sm-5">
								<input type="number" id="daysOffPerYear" class="form-control" 
										v-model="user.daysOffPerYear">
							</div>
						</div>
						<div class="form-group row">
							<label for="daysOff" class="col-sm-6 ml-2 col-form-label text-right">Leave So Far</label>
							<div class="col-sm-5">
								<input type="number" id="daysOff" class="form-control" 
										v-model="user.daysOff">
							</div>
						</div>

					</div>
				</div>

				<div class="col-sm-6">
					<div class="card" style="background-color:lightblue">

						<h5 class="card-title ml-2 text-center">Deductions</h5>
						<div class="form-group row">
							<label for="pf" class="col-sm-6 ml-2 col-form-label text-right">Provident Fund %</label>
							<div class="col-sm-5">
								<input type="number" id="pf" class="form-control" 
										v-model="user.dedPFpercent">
							</div>
						</div>
						<div class="form-group row">
							<label for="dedPT" class="col-sm-3 ml-2 col-form-label text-right">Prof Tax</label>
							<div class="col-sm-2">
								<input type="checkbox" id="dedPT" class="form-control" 
										v-model="user.dedPT">
							</div>

							<label for="dedESIC" class="col-sm-3 ml-2 col-form-label text-right">ESIC</label>
							<div class="col-sm-2">
								<input type="checkbox" id="dedESIC" class="form-control" 
										v-model="user.dedESIC">			
							</div>
						</div>

						<br>
						<h5 class="card-title ml-2 text-center">Advance</h5>
						<div class="form-group row">
							<label for="totalAdvance" class="col-sm-6 ml-2 col-form-label text-right">Advance</label>
							<div class="col-sm-5">
								<input type="number" id="totalAdvance" class="form-control" 
										v-model="user.totalAdvance">
							</div>
						</div>

						<br>
						<h5 class="card-title ml-2 text-center">Loan</h5>
						<div class="form-group row">
							<label for="totalLoan" class="col-sm-6 ml-2 col-form-label text-right">Loan Outstanding</label>
							<div class="col-sm-5">
								<input type="number" id="totalLoan" class="form-control" 
										v-model="user.totalLoan" disabled>
							</div>
						</div>
						<div class="form-group row">
							<label for="scheduledRepay" class="col-sm-6 ml-2 col-form-label text-right">Scheduled Repay</label>
							<div class="col-sm-5">
								<input type="number" id="scheduledRepay" class="form-control" 
										v-model="user.scheduledRepay">
							</div>
						</div>
						<div class="form-group row">
							<label for="onetimeRepay" class="col-sm-6 ml-2 col-form-label text-right">Onetime Repay</label>
							<div class="col-sm-5">
								<input type="number" id="onetimeRepay" class="form-control" 
										v-model="onetimeRepay">			
							</div>	
						</div>
						<div class="form-group row">
							<label for="addlLoan" class="col-sm-6 ml-2 col-form-label text-right">Additional Loan</label>
							<div class="col-sm-5">
								<input type="number" id="addlLoan" class="form-control" 
										v-model="addlLoan">			
							</div>	
						</div>
					</div>
				</div>

			</div>

			<p class="text-danger" align="left">{{userAlert}}</p>

			</form>

 		</CModal>
	</div>

    <!-- ---------------------------------------  User List -------------------------------------------------- -->

	<div align="center">
		<label for="loadingMsg" v-if="loading">{{loadingMsg}}</label>
		<scale-loader :loading="loading"></scale-loader>
	</div>

	<div class="row">
		<h5  class="ml-3">Download:</h5>

		<vue-excel-xlsx class="ml-3 mr-3"
			:data="rowUsers"
			:columns="colUsers"
			:filename="UserPayDataReportName"
			:sheetname="'Pay Data'"
			>
			<h5>User Pay Data Report</h5>
		</vue-excel-xlsx>
	</div>
	<br>

	<vue-good-table ref="usersTable" :columns="colUsers" :rows="rowUsers" 
							:pagination-options="pagination_options" :lineNumbers="true"
							@on-cell-click="rowChanged" 
						>
			<!-- <div slot="table-actions">
				<CButton class="ml-2 mr-3" color="primary" v-on:click.prevent="showReport()">
					User Pay Data Report
				</CButton>
			</div> -->
			<!-- <div slot="selected-row-actions">
				<CButton class="ml-2" color="info" v-on:click.prevent="openUserSalary()">
					Modify
				</CButton>
			</div> -->
			<template slot="table-row" slot-scope="props">
				<span v-if="props.column.field == 'edit'">
					<span><a href="#">Edit</a></span> 
				</span>
			</template>	
	</vue-good-table>

	<p class="text-danger" align="left">{{alert}}</p>

	<main id="main">
	</main>

  </div>
</template>

<script>
import axios from "axios"
import Datepicker from 'vuejs-datepicker'
import ScaleLoader from "@/views/utils/ScaleLoader"
import { firebase } from '@firebase/app'
import "firebase/auth"

export default {
	name: 'users',

    components: {
		ScaleLoader,
		Datepicker,
		},
		
	data () {
		return {
			alert: '',
			userAlert: '',
            loading: false,
			loadingMsg: null,

			profileModal: false,
			salaryModal: false,

			deptSelected: {'id': '', 'name': ''},

			profileBucket: '',

			deptList: [],

			users: [],
			userReportHtml: "",

			user: {
					userDocId: '',
					activeFlag: '',
					userId: '',
					name: '',
					phone: '',
					imei: '',
					deptId: '',
					deptName: '',
					address: '',
					profilePic: '',
					gender: 'M',
					joiningdate: '',
					leavingDate: '',
					IFSC: '',
					Bank: '',
					BankAccount: '',
			},

			addlLoan: 0,
			onetimeRepay: 0,

			addFlag: false,

            pagination_options: {
                enabled: true,
                mode: 'records',
                perPage: 10,
                position: 'top',
                perPageDropdown: [5, 10, 15, 20],
                dropdownAllowAll: false,
                setCurrentPage: 1,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Rows per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
            },

			UserPayDataReportName: "User Pay Data - " + new Date().toLocaleString(),

			colUsers: [
                	{
							label: '',
							field: 'edit',
							html: false,
							sortable: false,
                    },
					{
							label: 'User ID',
							field: 'userId',
							html: false,
							filterOptions: {enabled: false,},
					},
					{
							label: 'Department',
							field: 'deptName',
							html: false,
							filterOptions: {enabled: true,},
					},
					{
							label: 'Name',
							field: 'name',
							html: false,
							filterOptions: {enabled: true,},
					},
					{
							label: 'Total',
							field: 'salary',
							type: 'number',
							html: false
					},
					{
							label: 'Base',
							field: 'basePay',
							type: 'number',
							html: false
					},
					{
							label: 'HRA',
							field: 'hraPay',
							type: 'number',
							html: false
					},
					{
							label: 'Other',
							field: 'otherPay',
							type: 'number',
							html: false
					},
					{
							label: 'Advance',
							field: 'totalAdvance',
							type: 'number',
							html: false
					},
					{
							label: 'Loan',
							field: 'totalLoan',
							type: 'number',
							html: false
					},
			],

			rowUsers: [],
			curRowSelected: null,

		}
	},

	computed: {
	},

	mounted(){
		this.serverCall("getUsers")
	},

	methods: {
        serverCall(name) {
            var self = this
			self.alert = null

			firebase.auth().onAuthStateChanged(user => {
				if (user) {
					user.getIdToken(true).then(idToken => {
						var org = self.getUserOrg()
						switch(name) {
							case "getUsers":
								self.getUsers(idToken, org)
								break;
							case "saveUserSalary":
								self.saveUserSalary(idToken, org)
								break;
							default:
								console.log("Unknown function: " + name)
						}
					})
				}
				else {
					self.alert = "Please login first."
				}
			})

		},	

		previewFiles()
		{
			this.user.profilePic = this.$refs.profilePic.files[0]
		},

        // Fetch users for the given org
        getUsers(authToken, org) {
            var self = this
			self.alert = null

			// Set loading message
			self.loading = true
			self.loadingMsg = "Fetching Users..."

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/GetUsers/',
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data',
					},
				})
				.then(function (response) {
					if (response.data.err != ''){
						self.alert = response.data.err
					}
					else {
						self.deptList = response.data.deptList
						self.rowUsers =  response.data.userList
						// self.userReportHtml = response.data.userReportHtml
					}
					// Reset loading message
					self.loading = false
					self.loadingMsg = null
				})
				.catch(function (error) {
					console.log(String(error))
					self.alert = String(error)
					// Reset loading message
					self.loading = false
					self.loadingMsg = null
				})
		},

		rowChanged(params){	
			// Current selected Row
			if (this.curRowSelected != null){
				// If new row is not same as previous row, uncheck previous row
				if (this.curRowSelected.originalIndex!=params.row.originalIndex)
					this.curRowSelected.vgtSelected = false
			}
			// New selected row
			this.curRowSelected = params.row

			if (params.column.field=="edit"){
				this.openUserSalary()
			}
		},

		// Open user salary
		openUserSalary(){
            var self = this
			self.userAlert = null

            // Check if User is selected
			if (self.curRowSelected==null){
				self.alert = "User not selected."
				return
			}

			// Initialize user object
			self.user = self.curRowSelected
			// Initialize other values
			self.addlLoan = 0
			self.onetimeRepay = 0

			// Show modal with user values
			self.salaryModal = true

		},

		// Save user salary changes
        saveUserSalary(authToken, org) {
            var self = this
            this.userAlert = ""

            if (!self.user.userDocId) {
                self.userAlert= 'User not specified.'
                return
            }

			var formData = new FormData()
			formData.append("userDataStr", JSON.stringify(self.user))
			formData.append("addlLoan", self.addlLoan)
			formData.append("onetimeRepay", self.onetimeRepay)

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/saveUserSalary/',
					data: formData,
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': self.getUserOrg(),
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if (response.data.err != '') {
						self.userAlert = response.data.err
					}
					else {
						// Refresh user list on the screen
						self.serverCall("getUsers")						
						//$('#userSalaryModal').modal('hide')
						self.salaryModal = false
					}
				})
				.catch(function (error) {
					self.userAlert = String(error)
				})	
		},

		showReport() {
            var self = this
			self.alert = null

			var win = window.open("", "User Report");
			win.document.body.innerHTML = self.userReportHtml;
		},

	},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
